import Icon, { IconType } from 'ui/Icon';
import Menu from 'ui/Menu';
import { Text } from 'ui/Typography';

import { useAppEnvironmentContext } from '../../../contexts/appEnvironmentContext';

type Props = {
  value: string;
  icon: IconType;
  label: string;
  href?: string;
  onClick?: () => void;
  isDanger?: boolean;
};

const UserMenuLink: React.FC<Props> = ({
  value,
  icon,
  label,
  href,
  onClick,
  isDanger,
}) => {
  const { appEnvironment } = useAppEnvironmentContext();
  const isExternal = appEnvironment === 'office';

  return (
    <Menu.Item asChild value={value} isDanger={isDanger}>
      {/* See https://www.chakra-ui.com/docs/components/menu#links */}
      <a
        href={href}
        onClick={onClick}
        // Open links in a new tab in the Office add-in environment
        {...(isExternal
          ? { target: '_blank', rel: 'noopener noreferrer' }
          : {})}
      >
        <Icon icon={icon} opacity={0.8} textAlign="center" w={5} />
        <Text>{label}</Text>
      </a>
    </Menu.Item>
  );
};

export default UserMenuLink;
